import {
	BrowserRouter as Router,
	Route,
	Routes,
	useLocation,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Error404 from "../../containers/errors/Error404";
import Login from "../../containers/auth/Login";
import Dashboard from "../../containers/Dashboard";
import BusinessProfile from "../../containers/pages/BusinessProfile";
import PrivateRoute from "./PrivateRoutes";
import Profile from "../../containers/pages/Profile";
import ResetPassword from "../../containers/auth/ResetPassword";
import ResetPasswordConfirm from "../../containers/auth/ResetPasswordConfirm";
import ActivateAccount from "../../containers/auth/ActivateAccount";

import TermsOfService from "../../containers/legal/TermsOfService";
import PrivacyPolicy from "../../containers/legal/PrivacyPolicy";
import CookiePolicy from "../../containers/legal/CookiePolicy";
import TablesBusiness from "../../containers/pages/TablesBusiness";
import DeleteAccount from "../../containers/legal/DeleteAccount";

function AnimatedRoutes() {
	const location = useLocation();
	return (
		<AnimatePresence>
			<Routes location={location} key={location.pathname}>
				<Route path="*" element={<Error404 />} />
				<Route path="/" element={<Login />} />

				<Route path="/forgot_password" element={<ResetPassword />} />
				<Route
					path="/password/reset/confirm/:uid/:token"
					element={<ResetPasswordConfirm />}
				/>
				<Route path="/active/:uid/:token" element={<ActivateAccount />} />

				{/* Inicio dash */}
				<Route
					path="/dashboard"
					element={
						<PrivateRoute>
							<Dashboard />
						</PrivateRoute>
					}
				/>

				<Route
					path="/profile"
					element={
						<PrivateRoute>
							<Profile />
						</PrivateRoute>
					}
				/>

				<Route
					path="/mi-restaurante"
					element={
						<PrivateRoute>
							<BusinessProfile />
						</PrivateRoute>
					}
				/>

				<Route
					path="/mesas"
					element={
						<PrivateRoute>
							<TablesBusiness />
						</PrivateRoute>
					}
				/>
				<Route path="/legal/TermsOfService" element={<TermsOfService />} />
				<Route path="/legal/PrivacyPolicy" element={<PrivacyPolicy />} />
				<Route path="/legal/CookiePolicy" element={<CookiePolicy />} />
				<Route path="/legal/DeleteAccount" element={<DeleteAccount />} />
			</Routes>
		</AnimatePresence>
	);
}

export default AnimatedRoutes;
